import React from "react";
import { MarketingNav, MarketingFooter } from "@/components/marketing/MarketingChrome";
import { PricingTable, EnterpriseEnquiry } from "@/components/marketing/PricingTable";

export default function Pricing() {
  return (
    <div className="marketing-root min-h-screen bg-[color:var(--marketing-bg)] text-[color:var(--marketing-text)]">
      <MarketingNav active="Pricing" />
      <main data-testid="pricing-page" className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-24">
        <p className="overline-label">Pricing</p>
        <h1 className="mt-4 max-w-3xl font-marketing-display text-4xl font-black leading-none tracking-tight sm:text-5xl">
          Priced for PMOs, not for seat counts you will never use.
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[color:var(--marketing-text-muted)]">
          Foundation gets a small team started properly. Professional is where most PMOs live. Enterprise
          adds the data-boundary controls and assurance evidence that regulated and public sector buyers
          are obliged to ask for.
        </p>
        <div className="mt-14">
          <PricingTable />
        </div>
        <div id="enquiry" className="mt-24 scroll-mt-24">
          <EnterpriseEnquiry />
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}
